import React, { useState, useEffect, useRef } from 'react'
import { Row, Col, Button, Container, Modal } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import TopHeader from '../components/TopHeader';
import LeftNavbar from '../components/LeftNavbar';
import Select from 'react-select';
//import { suburbData } from '../assets/data/suburbData';
import axios from 'axios';
import { BASE_URL } from '../components/App';
import { FranchiseeFormValidation, normalizeFranchiseeFormValue, handleFranchiseeKeyDown } from '../helpers/validation';
import * as ReactBootstrap from 'react-bootstrap';
import DragDropSingle from '../components/DragDropSingle';
import ImageCropPopup from '../components/ImageCropPopup/ImageCropPopup';
import { SessionKeys } from '../constant';

const NewFranchisees = () => {

    // REF REFERENCES
    let franchisee_name = useRef(null);
    let abn = useRef(null);
    let city = useRef(null);
    let state = useRef(null);
    let franchisee_number = useRef(null);
    let acn = useRef(null);
    let postcode = useRef(null);
    let address = useRef(null);
    let contact = useRef(null);

    const [franchiseeData, setFranchiseeData] = useState({
        franchisee_name: "",
        abn: "",
        city: "",
        state: "",
        franchisee_number: "",
        acn: "",
        address: "",
        postcode: "",
        contact: "",
    });
    // const [cityData, setCityData] = useState([]);
    const [cityData, setCityData] = useState([]);

    const [selectedFranchisee, setSelectedFranchisee] = useState();
    const [topErrorMessage, setTopErrorMessage] = useState(null);
    const [loader, setLoader] = useState(false);
    const [createFranchiseeModal, setCreateFranchiseeModal] = useState(false);
    const [suburbSearchString, setSuburbSearchString] = useState("");
    const [stateData, setStateData] = useState(null);
    const [suburbMenuOpen, setSuburbMenuOpen] = useState(false);
    const [image, setImage] = useState([]);
    const [croppedImage, setCroppedImage] = useState(null);
    const [popupVisible, setPopupVisible] = useState(false);

    // ERROR STATES
    const [formErrors, setFormErrors] = useState({});

    // CREATES A NEW FRANCHISEE
    const createFranchisee = async () => {
        try {
            const data = new FormData();
            Object.keys(franchiseeData).forEach((key) => {
                data.append(key, franchiseeData[key] ?? '');
            });

            if (croppedImage && typeof croppedImage === 'object') {
                const blob = await fetch(croppedImage.getAttribute('src')).then((res) =>
                    res.blob()
                );
                data.append('branding_photo', blob, 'branding.jpg');
            }

            const response = await axios.post(`${BASE_URL}/role/franchisee`, data, {
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem('token')
                }
            });

            if(response.status === 201 && response.data.status === "success") {
                setLoader(false);
                setCreateFranchiseeModal(false);
                sessionStorage.removeItem(SessionKeys.RolesFranchiseeList);
                sessionStorage.removeItem(
                  `${SessionKeys.RolesFranchiseeList}_${localStorage.getItem('user_id') || ''}`
                );
                localStorage.setItem('success_msg', 'Franchise Created Successfully!');
                window.location.href="/all-franchisees";
            } else {
                setLoader(false);
                setCreateFranchiseeModal(false);
                const apiErrors = response.data?.errors;
                if (apiErrors && typeof apiErrors === 'object') {
                    setFormErrors((prevState) => ({ ...prevState, ...apiErrors }));
                    setAutoFocus(apiErrors);
                } else {
                    let { message } = response.data;
                    setFormErrors(prevState => ({
                        ...prevState,
                        franchisee_name: message
                    }));
                }
            }
        } catch (error) {
            setLoader(false);
            setCreateFranchiseeModal(false);
            const apiErrors = error.response?.data?.errors;
            if (apiErrors && typeof apiErrors === 'object') {
                setFormErrors((prevState) => ({ ...prevState, ...apiErrors }));
                setAutoFocus(apiErrors);
            } else {
                setFormErrors((prevState) => ({
                    ...prevState,
                    franchisee_name:
                        error.response?.data?.message || 'Unable to create franchise',
                }));
            }
        }
    }

    const fetchSuburbData = (state) => {
        if (!state || state === 'undefined' || state === 'null') {
            setCityData([]);
            return;
        }

        const suburbAPI = `${BASE_URL}/api/suburbs/data/${encodeURIComponent(state)}`;
        axios
            .get(suburbAPI, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            })
            .then((response) => {
                const sdata = response?.data?.data || [];
                setCityData(
                    sdata.map((d) => ({
                        id: d.id,
                        value: d.name,
                        label: d.name,
                    }))
                );
            })
            .catch(() => {
                setCityData([]);
            });
    };
    // FETCHES AUSTRALIAN STATES FROM THE DATABASE AND POPULATES THE DROP DOWN LIST
    const fetchStateList = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/api/state/data`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });

            if (response.status === 200 && response.data.status === 'success') {
                const { states } = response.data;
                setStateData(
                    states.map((d) => ({
                        id: d.id,
                        value: d.name,
                        label: d.name,
                    }))
                );
            }
        } catch (error) {
            setStateData([]);
        }
    };

    const setAutoFocus = (errObj) => {
        const errArray = Object.keys(errObj);

        if(errArray.includes('franchisee_name')) {
          franchisee_name.current.focus();
        } else if(errArray.includes('franchisee_number')) {
          franchisee_number.current.focus();
        } else if(errArray.includes('abn')) {
          abn.current.focus();
        } else if(errArray.includes('acn')) {
          acn.current.focus();
        } else if(errArray.includes('city')) {
          city.current.focus();
        } else if(errArray.includes('address')) {
          address.current.focus();
        } else if(errArray.includes('state')) {
          state.current.focus();
        } else if(errArray.includes('postcode')) {
          postcode.current.focus();
        } else if(errArray.includes('contact')) {
          contact.current.focus();
        } 
      }

    const handleFranchiseeDataSubmission = event => {
        event.preventDefault();

        let errorObject = FranchiseeFormValidation(franchiseeData);

        if(Object.keys(errorObject).length > 0) {
            setFormErrors(errorObject);
            setAutoFocus(errorObject);
        } else {
            setCreateFranchiseeModal(true);
            setLoader(true)
            createFranchisee();
        }
    }

    const handleChange = (event) => {
        const { name, value } = event.target;

        setFranchiseeData((prevState) => ({
            ...prevState,
            [name]: normalizeFranchiseeFormValue(name, value),
        }));
    };

    const handleFieldChange = (event) => {
        handleChange(event);
        setFormErrors((prevState) => ({
            ...prevState,
            [event.target.name]: null,
        }));
    };

    const handleFieldKeyDown = (event) => {
        handleFranchiseeKeyDown(
            event.target.name,
            event,
            franchiseeData[event.target.name]
        );
    };

    const handleSuburbMenuOpen = () => {
        if (!franchiseeData?.state?.trim()) {
            setSuburbMenuOpen(false);
            setFormErrors((prevState) => ({
                ...prevState,
                state: 'Please select State first',
            }));
            return;
        }
        setSuburbMenuOpen(true);
    };

    const handleSuburbMenuClose = () => {
        setSuburbMenuOpen(false);
    };

    const handleCancel = () => {
        window.location.href="/all-franchisees";
    }
    useEffect(() => {
        fetchStateList();
    }, []);

    useEffect(() => {
        fetchSuburbData(franchiseeData?.state);
      }, [franchiseeData?.state])


    return (
        <div>
            <div id="main">
                <section className="mainsection">
                    <Container>
                        <div className="admin-wrapper">
                            <aside className="app-sidebar">
                                <LeftNavbar />
                            </aside>
                            <div className="sec-column">
                                <TopHeader 
                                    selectedFranchisee={selectedFranchisee}
                                    setSelectedFranchisee={setSelectedFranchisee} />
                                <div className="entry-container">
                                    <div className="user-management-sec">
                                        <header className="title-head">
                                            <h1 className="title-lg">Add Franchise</h1>
                                        </header>
                                    </div>
                                </div>
                                {topErrorMessage && <p className="alert alert-danger" style={{ position: "fixed", left: "50%", top: "0%", zIndex: 1000 }}>{topErrorMessage}</p>}
                                <div className="new-user-sec">
                                    <div className="user-pic-sec">
                                        <DragDropSingle
                                            croppedImage={croppedImage}
                                            setCroppedImage={setCroppedImage}
                                            onSave={setImage}
                                            setPopupVisible={setPopupVisible}
                                            setFormErrors={setFormErrors}
                                            fetchedPhoto={''}
                                            infoText="Upload branding photo for this franchise here"
                                            maxSizeMB={2}
                                            errorKey="branding_photo"
                                        />
                                        {popupVisible && (
                                            <ImageCropPopup
                                                image={image}
                                                setCroppedImage={setCroppedImage}
                                                setPopupVisible={setPopupVisible}
                                            />
                                        )}
                                        {formErrors.branding_photo && (
                                            <span className="error d-block text-center mt-1">{formErrors.branding_photo}</span>
                                        )}
                                    </div>
                                    <Form onSubmit={handleFranchiseeDataSubmission} className="error-sec user-form">
                                    <Row>
                                        <Col sm={6} md={6} lg={6}>
                                            <Form.Group className="mb-3 relative" controlId="formBasicEmail">
                                                <Form.Label>Franchise Name *</Form.Label>
                                                <Form.Control
                                                    name="franchisee_name" 
                                                    type="text"
                                                    maxLength={35}
                                                    value={franchiseeData.franchisee_name}
                                                    ref={franchisee_name}
                                                    onKeyDown={handleFieldKeyDown}
                                                    onChange={handleFieldChange} />
                                                { formErrors.franchisee_name !== null && <span className="error">{formErrors.franchisee_name}</span> }
                                            </Form.Group>

                                            <Form.Group className="mb-3 relative" controlId="formBasicPassword">
                                                <Form.Label>ABN *</Form.Label>
                                                <Form.Control
                                                    name="abn" 
                                                    type="text" 
                                                    value={franchiseeData.abn}
                                                    ref={abn}
                                                    maxLength={11}
                                                    inputMode="numeric"
                                                    placeholder="12345678901"
                                                    onKeyDown={handleFieldKeyDown}
                                                    onChange={handleFieldChange} />
                                                { formErrors.abn !== null && <span className="error">{formErrors.abn}</span> }
                                            </Form.Group>

                                            <Form.Group className="mb-3 relative">
                                                <Form.Label>State *</Form.Label>
                                                <Select
                                                placeholder="Select"
                                                ref={state}
                                                closeMenuOnSelect={true}
                                                options={stateData}
                                                onChange={(e) => {
                                                    setFranchiseeData((prevState) => ({
                                                        ...prevState,
                                                        state: e.value,
                                                        city: '',
                                                    }));
                                                    setFormErrors(prevState => ({
                                                        ...prevState,
                                                        state: null,
                                                        city: null,
                                                    }));
                                                    setSuburbMenuOpen(false);
                                                }} />
                                            { formErrors.state !== null && <span className="error">{formErrors.state}</span> }
                                            </Form.Group>
                                            
                                            <Form.Group className="mb-3 relative">
                                                <Form.Label>Suburb *</Form.Label>
                                                <Select
                                                placeholder={franchiseeData?.state ? 'Select' : 'Select State first'}
                                                ref={city}
                                                closeMenuOnSelect={true}
                                                options={cityData}
                                                menuIsOpen={suburbMenuOpen}
                                                onMenuOpen={handleSuburbMenuOpen}
                                                onMenuClose={handleSuburbMenuClose}
                                                onInputChange={(e) => {
                                                    setSuburbSearchString(e);
                                                  }}
                                                onChange={(e) => {
                                                    setFranchiseeData((prevState) => ({
                                                        ...prevState,
                                                        city: e.value,
                                                    }));
                                                    setFormErrors(prevState => ({
                                                        ...prevState,
                                                        city: null
                                                    }));
                                                    setSuburbMenuOpen(false);
                                                }} />
                                            { formErrors.city !== null && <span className="error">{formErrors.city}</span> }
                                            </Form.Group>
                                            
                                            <Form.Group className="mb-3 relative" controlId="formBasicPassword">
                                                <Form.Label>Contact Number *</Form.Label>
                                                <Form.Control 
                                                    name="contact"
                                                    type="text"
                                                    value={franchiseeData.contact}
                                                    ref={contact}
                                                    maxLength={10}
                                                    inputMode="numeric"
                                                    placeholder="0212345678"
                                                    onKeyDown={handleFieldKeyDown}
                                                    onChange={handleFieldChange} />
                                                { formErrors.contact !== null && <span className="error">{formErrors.contact}</span> }
                                            </Form.Group>

                                         
                                        </Col>

                                        <Col sm={6} md={6} lg={6}>
                                            <Form.Group className="mb-3 relative" controlId="formBasicEmail">
                                                <Form.Label>CC Provider ID *</Form.Label>
                                                <Form.Control 
                                                    name="franchisee_number"
                                                    type="text" 
                                                    value={franchiseeData.franchisee_number}
                                                    ref={franchisee_number}
                                                    maxLength={10}
                                                    placeholder="123456789A"
                                                    onKeyDown={handleFieldKeyDown}
                                                    onChange={handleFieldChange} />
                                                { formErrors.franchisee_number !== null && <span className="error">{formErrors.franchisee_number}</span> }
                                            </Form.Group>

                                            <Form.Group className="mb-3 relative" controlId="formBasicPassword">
                                                <Form.Label>ACN *</Form.Label>
                                                <Form.Control
                                                    name="acn" 
                                                    type="text" 
                                                    value={franchiseeData.acn}
                                                    ref={acn}
                                                    maxLength={11}
                                                    inputMode="numeric"
                                                    placeholder="12345678901"
                                                    onKeyDown={handleFieldKeyDown}
                                                    onChange={handleFieldChange} />
                                                { formErrors.acn !== null && <span className="error">{formErrors.acn}</span> }
                                            </Form.Group>

                                            <Form.Group className="mb-3 relative" controlId="formBasicPassword">
                                                <Form.Label>Street Address *</Form.Label>
                                                <Form.Control 
                                                    name="address"
                                                    type="text"
                                                    value={franchiseeData.address}
                                                    ref={address}
                                                    onChange={handleFieldChange} />
                                                { formErrors.address !== null && <span className="error">{formErrors.address}</span> }
                                            </Form.Group>

                                            <Form.Group className="mb-3 relative" controlId="formBasicPassword">
                                                <Form.Label>Post Code *</Form.Label>
                                                <Form.Control
                                                    name="postcode" 
                                                    type="text" 
                                                    value={franchiseeData.postcode}
                                                    ref={postcode}
                                                    maxLength={4}
                                                    inputMode="numeric"
                                                    placeholder="3000"
                                                    onKeyDown={handleFieldKeyDown}
                                                    onChange={handleFieldChange} />
                                                { formErrors.postcode !== null && <span className="error">{formErrors.postcode}</span> }
                                            </Form.Group>
                                            
                                           

                                          
                                        </Col>

                                        <div className="d-flex justify-content-center my-5">
                                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                                <Button 
                                                    variant="link btn btn-light btn-md m-2" 
                                                    style={{ backgroundColor: '#efefef' }}
                                                    onClick={() => handleCancel()}>
                                                Cancel
                                                </Button>
                                                <Button type="submit">Save Details</Button>
                                            </Form.Group>
                                        </div>
                                    </Row>
                                </Form>
                                </div>
                            </div>
                        </div>
                    </Container>
                </section>
            </div >
            {
                createFranchiseeModal && 
                <Modal
                show={createFranchiseeModal}
                onHide={() => setCreateFranchiseeModal(false)}>
                    <Modal.Header>
                        <Modal.Title>
                        Creating Franchise
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="create-training-modal" style={{ textAlign: 'center' }}>
                        <p>Franchise is being created!</p>
                        <p>Please Wait...</p>
                        </div>
                    </Modal.Body>

                    <Modal.Footer style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    {
                        loader === true && <div>
                        <ReactBootstrap.Spinner animation="border" />
                        </div>
                    }
                    </Modal.Footer>
                </Modal>
            }
        </div >
    )
}

export default NewFranchisees;